import { injectable } from 'inversify';
import Shepherd from 'shepherd.js';
import { resolve, Resolver } from '../Container';
import * as Tours from './TourDefinitions';

@injectable()
export class TourManager {

    @resolve(Resolver) private resolver!: Resolver;

    private active = null as Shepherd.Tour;
    private activeName = null as string;

    public get current() {
        return this.activeName;
    }

    public start(tourName: keyof typeof Tours) {
        this.cancel();
        const impl = Tours[tourName];
        if (impl) {
            this.activeName = tourName;
            this.active = impl(this.resolver);
            this.active.on('complete', () => void (this.active = null));
            this.active.start();
        }
    }

    public complete() {
        if (this.active) {
            this.active.complete();
            this.active = null;
            this.activeName = null;
        }
    }

    public cancel() {
        if (this.active) {
            this.active.cancel();
            this.active = null;
            this.activeName = null;
        }
    }
}
